import type { ImgHTMLAttributes } from 'react'

type Props = ImgHTMLAttributes<HTMLImageElement> & {
  alt: string
  /** Immagine above the fold (LCP): caricata subito e con priorità alta */
  priority?: boolean
}

// Il sito è statico: niente ottimizzatore a runtime. Le immagini vanno già ottimizzate
// (formato e dimensioni) in public/static/images prima di essere referenziate.
export default function Image({ priority, alt, ...rest }: Props) {
  return (
    <img
      loading={priority ? 'eager' : 'lazy'}
      decoding="async"
      fetchPriority={priority ? 'high' : undefined}
      alt={alt}
      {...rest}
    />
  )
}
